import React, { useEffect, useState } from "react";
import SideNav from "../LayoutElements/Sidenav";
import { getSidenavItems } from "../layout/data";
import { useSelector } from "react-redux";

const Sidenav = (props) => {
  const [sidenavItems, setSidenavItems] = useState([]);
  const { user, permissions } = useSelector((state) => state);
  const role = user.currentUser?.Role_id;

  useEffect(() => {
    setSidenavItems(getSidenavItems(permissions, user.currentUser.isAdminOrEmp, role));
  }, [permissions]);

  return <SideNav {...props} sidenavItems={sidenavItems} userDetails={user} />;
};

export default Sidenav;
